module.exports = __webpack_public_path__ + "img/Navigate_symbol_no_background_RGB_small.e25b7a2d.png";